export default "__VITE_ASSET__0i9uclyg__"